import packageInfo from '../../package.json';
export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyD5yZOGCmhsaJ8S8IQSGM4aVu6iKBsKMTM",
    authDomain: "axxessnetworks-txb.firebaseapp.com",
    projectId: "axxessnetworks-txb",
    storageBucket: "axxessnetworks-txb.firebasestorage.app",
    messagingSenderId: "1099102639378",
    appId: "1:1099102639378:web:45d5c9e1fd2911fbe80fcb"
  },
  appName: 'Axx Chat',
  webAppURL: 'https://axxchat.axxessnetworks.com/',
  apiBase: 'https://axxessnetworks-txb.textable.app/',
  enforceBilling: false,
  isPrivateLabel: true,
  showSignup: false,
  disableDelete: false,
  liveDeployVersion: packageInfo.version,
  privacyUrl: 'https://www.axxessnetworks.com/privacy-policy/'
};